<template>
	<home-tile
		class="whole-dollar-tile"
		color="cerulean"
		button-title="Set RoundUp"
		:loading="isLoading"
		@click="onSubmit"
	>
		<div>
			<h3 style="color: white">Set Whole Dollar RoundUps</h3>
			<p :style="{ marginTop: '0px' }">
				When a transaction ends on the Whole Dollar ($1.00, $2.00, etc),
				choose the amount we should round up!
			</p>
			<segment-toggle
				:value="wholeDollar"
				:options="options"
				@on-change="setAmount"
				name="wholeDollar"
				labelPrefix="$"
				:labelParse="(val) => (val / 100).toFixed(2)"
			/>
		</div>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import HomeTile from './HomeTile'
import SegmentToggle from '../../ui/SegmentToggle'

export default {
	name: 'whole-dollar-tile',
	components: { HomeTile, SegmentToggle },
	data() {
		return {
			options: [0, 25, 50, 75, 100],
			wholeDollar: 50,
			isLoading: false
		}
	},
	computed: {
		...mapGetters(['user'])
	},
	methods: {
		...mapActions(['updateUser']),
		setAmount(val) {
			this.wholeDollar = val
		},
		onSubmit() {
			this.isLoading = true
			window.analytics.track('set_whole_dollar_amount', {
				amount: this.wholeDollar
			})
			const user = {
				whole_transaction_amount: this.wholeDollar,
				minimum_donation: this.user.minimum_donation,
				email: this.user.email,
				phone: this.user.phone
			}
			this.updateUser(user)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Success',
						'Your Whole Dollar RoundUp has been set! Now your Whole Dollar Transactions will donate $' +
							(this.wholeDollar / 100).toFixed(2) +
							'!'
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		}
	},
	mounted() {
		this.wholeDollar = this.user.whole_transaction_amount
	}
}
</script>

<style lang="scss">
.whole-dollar-tile {
	.body {
		padding-left: 20px;
		padding-right: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.segmented-control {
		background: $navy;
		display: flex;
		width: 100%;
		margin-top: 20px;
		margin-bottom: 0px;
		padding: 0;
		border-radius: 25px;
		.segmented-control__item {
			flex-grow: 1;
			flex-basis: 0;
			margin: 0;
			padding: 0;
			list-style-type: none;
		}
		.segmented-control__input {
			position: absolute;
			visibility: hidden;
			&:checked {
				& + .segmented-control__label {
					background: $white;
					color: $navy-highlight;
				}
			}
		}
		.segmented-control__label {
			display: block;
			padding: 15px 10px;
			text-align: center;
			cursor: pointer;
			border-radius: 25px;
			font-weight: bold;
			&:hover {
				background: $navy-highlight;
				color: $white;
			}
		}
	}
}
</style>
